import React from 'react'
import {change as changeFieldValue, Field, formValueSelector, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {
  alterarMotorista,
  buscarMotorista,
  cadastrarMotorista,
  excluirMotorista
} from '../../../actions/motorista/motoristaActions';
import {renderFieldDataNascimento, required, requiredSelect, renderFieldNumeros} from '../../../util/inputs';
import {renderField} from '../../../util/arraysUtil';
import Estados from '../../comum/Estados';
import $ from 'jquery';
import CategoriaCNH from '../../comum/CategoriaCNH';
import {showSuccessMsg} from '../../../util/messagesUtil';


export class ModalCadastrarMotorista extends React.Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
    }

    handleEstado(estado) {
        console.log(estado)

    }

    exibirComboEstado(event) {
        return <Estados event={event} handleEstado={this.handleEstado.bind(this)}/>

    }

    exibirComboCategoriaCNH(event) {
        return <CategoriaCNH event={event}/>

    }

    cadastrar(motorista) {
        this.props.cadastrarMotorista(motorista, this.props.empresaSelecionada.id)
            .then(() => {
                showSuccessMsg('Motorista cadastrado com sucesso');
            })
    }

    alterar(motorista) {
        this.props.alterarMotorista(motorista, this.props.empresaSelecionada.id)
            .then(() => {
                showSuccessMsg('Motorista alterado com sucesso');
            })
    }

    limparFormulario() {
        this.props.changeFieldValue('formCadastrarMotorista',
            'numeroRegistroCNH', '');
        this.props.changeFieldValue('formCadastrarMotorista',
            'categoriaCNH', '');
        this.props.changeFieldValue('formCadastrarMotorista',
            'docIdentidadeEmissor', '');
        this.props.changeFieldValue('formCadastrarMotorista',
            'estadoEmissao', '');
        this.props.changeFieldValue('formCadastrarMotorista',
            'validadeCNH', '');
        this.props.changeFieldValue('formCadastrarMotorista',
            'validadeRegistroANTT', '');
        this.props.changeFieldValue('formCadastrarMotorista',
            'numeroRegistroANTT', '');
        this.props.changeFieldValue('formCadastrarMotorista',
            'idMotorista', null);
    }

    excluirMotorista(codigoEmpresa, codigoMotorista) {
        this.props.excluirMotorista(codigoEmpresa, codigoMotorista).then(() => {
              showSuccessMsg('Motorista excluído com sucesso');
        })
        this.limparFormulario();
    }

    fecharModal() {
        $('#formCadastrarMotorista')
            .modal('hide');
        $('#formCadastrarMotorista')
            .hide();
        $('.modal-backdrop')
            .hide();
        this.props.reset('formCadastrarMotorista')
    }

    submit(values) {
        const dadosMotorista = {
            id: values.idMotorista,
            numeroRegistroCNH: values.numeroRegistroCNH,
            validadeCNH: values.validadeCNH,
            categoriaCNH: values.categoriaCNH.value,
            uf: values.estadoEmissao.value,
            docIdentidadeEmissor: values.docIdentidadeEmissor,
            numeroRegistroANTT: values.numeroRegistroANTT,
            validadeRegistroANTT: values.validadeRegistroANTT,
            codigoUsuarioEmpresa: this.props.usuarioSelecionado.usuarioEmpresaId
        }
        if (values.idMotorista) {
            this.alterar(dadosMotorista)
        } else {
            this.cadastrar(dadosMotorista)
        }
    }

    render() {
        const {
            handleSubmit, submitting, invalid, pristine
        } = this.props;
        return (
            <div className="modal fade show" id='modalCadastrarMotorista' role='dialog'
                 aria-labelledby='modalCadastrarMotorista' aria-hidden='true' data-backdrop='static'>
                <div className={'modal-dialog modal-dialog-centered modal-lg'}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>Cadastro de motorista</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                    onClick={() => this.limparFormulario()}>
                                <i className="material-icons">
                                    &#xe5cd;
                                </i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit(this.submit)}>
                                <div className="form-row">
                                    <div className="col-12 col-sm-5 col-md-5">
                                        <Field name="numeroRegistroCNH" type="text" required={true}
                                               component={renderFieldNumeros}
                                               validate={[required]}
                                               label="Nº registro:"
                                               css="form-control"/>
                                    </div>
                                    <div className="col-12 col-sm-2 col-md-2">
                                        <Field name="validadeCNH" type="text" required={true}
                                               component={renderFieldDataNascimento}
                                               validate={[required]}
                                               css="form-control" label="Validade da CNH"/>
                                    </div>
                                    <div className="col-12 col-sm-4 col-md-4 mt-2">
                                        <label>Categoria da CNH</label>
                                        <Field name='categoriaCNH' validate={[requiredSelect]}
                                               component={this.exibirComboCategoriaCNH.bind(this)}/>
                                    </div>
                                </div>
                                <div className="form-row mt-2">
                                    <div className="col-12 col-sm-9 col-md-6">
                                        <label>Estado emissão</label>
                                        <Field name='estadoEmissao' label="Estado"
                                               validate={[requiredSelect]}
                                               component={this.exibirComboEstado.bind(this)}/>
                                    </div>
                                </div>
                                <div className="form-row">
                                    <div className="col-12 col-sm-5 col-md-5">
                                        <Field name="docIdentidadeEmissor" type="text" required={true}
                                               component={renderField}
                                               validate={[required]}
                                               label="Doc. identidade emissor"
                                               css="form-control"/>
                                    </div>
                                    <div className="col-12 col-sm-4 col-md-4">
                                        <Field name="numeroRegistroANTT" type="text" required={true}
                                               component={renderFieldNumeros}
                                               validate={[required]}
                                               label="Nº registro ANTT"
                                               css="form-control"/>
                                    </div>
                                    <div className="col-12 col-sm-3 col-md-3">
                                        <Field name="validadeRegistroANTT" type="text" required={true}
                                               component={renderFieldDataNascimento}
                                               validate={[required]}
                                               css="form-control" label="Validade do registro ANTT"/>
                                    </div>
                                </div>
                                <div className="form-group area-codigo">
                                    <Field name="idMotorista" type="hidden" component={renderField}
                                           css="form-control col-md-12"/>
                                </div>
                                <div className='col-10 col-sm-10 col-md-8 '>
                                    <button id="btn-salvar"
                                            type="submit" disabled={invalid || submitting || pristine}
                                            className="btn btn-laranja mt-2">{this.props.idMotorista ? 'Alterar' : 'Incluir'}
                                    </button>
                                    {this.props.idMotorista ?
                                        <button id="btn-excluir"
                                                type="button"
                                                onClick={() => this.excluirMotorista(this.props.empresaSelecionada.id, this.props.idMotorista)}
                                                data-dismiss="modal" aria-label="Close"
                                                className="btn btn-laranja mt-2 ml-2">Excluir
                                        </button> : ''
                                    }
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        idMotorista: formValueSelector('formCadastrarMotorista')(state, 'idMotorista'),
        empresaSelecionada: state.empresaSelecionada,
        usuarioSelecionado: state.usuarioSelecionado
    }
}


export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        cadastrarMotorista,
        alterarMotorista,
        buscarMotorista,
        excluirMotorista
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formCadastrarMotorista'
})(ModalCadastrarMotorista));
